<script setup lang="ts">
import { ref, computed } from 'vue';
import { DatePicker } from 'primevue';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';

const fromDate = ref<Date | undefined>(undefined);
const toDate = ref<Date | undefined>(undefined);

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

// Get the locale for DatePicker
const datePickerLocale = computed(() => {
  return languageStore.getPrimeVueLocale();
});

// Date format for DatePicker (PrimeVue format, not Intl format)
const dateFormat = computed(() => {
  return languageStore.getPrimeVueDateFormat();
});

defineExpose({
  getFilterValues() {
    return {
      from: fromDate.value ? getLocalDateString(fromDate.value) : '',
      to: toDate.value ? getLocalDateString(toDate.value) : ''
    };
  }
});

function getLocalDateString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
</script>

<template>
  <div>
    <label id="from" class="me-1">{{ translations.generic.from }}</label>
    <DatePicker v-model="fromDate" :show-icon="true" :max-date="toDate" :locale="datePickerLocale"
      :dateFormat="dateFormat" aria-labelledby="from" />

    <label id="to" class="ms-3 me-1">{{ translations.generic.to }}</label>
    <DatePicker v-model="toDate" :show-icon="true" :min-date="fromDate" :locale="datePickerLocale"
      :dateFormat="dateFormat" aria-labelledby="to" />
  </div>
</template>
